import { Reducer } from 'redux';
import { TransportCardsState, TransportCardsTypes } from './types';

const INITIAL_STATE: TransportCardsState = {
  transportCardsList: [],
  transportCardsListFull: [],
  transportCardData: {
    id: '',
    type: 0,
    status: 0,
    number: '',
    cardNumber: '',
    lot: '',
    userId: '',
    code: '',
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
  },
  transportCardSettings: null,
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<TransportCardsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST TRANSPORT CARDS
    case TransportCardsTypes.LIST_TRANSPORT_CARDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        ...(!action.payload?.isCsvFull && {
          transportCardsList: INITIAL_STATE.transportCardsList,
        }),
      };
    case TransportCardsTypes.LIST_TRANSPORT_CARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...(!action.payload?.isCsvFull && {
          transportCardsList: action.payload.transportCardsList,
        }),
        ...(action.payload?.isCsvFull && {
          transportCardsListFull: action.payload.transportCardsList,
        }),
        totalCount: action.payload.totalCount,
      };
    case TransportCardsTypes.LIST_TRANSPORT_CARDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardsList: INITIAL_STATE.transportCardsList,
      };

    // GET TRANSPORT CARD
    case TransportCardsTypes.GET_TRANSPORT_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardData: INITIAL_STATE.transportCardData,
      };
    case TransportCardsTypes.GET_TRANSPORT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardData: action.payload.transportCardData,
      };
    case TransportCardsTypes.GET_TRANSPORT_CARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardData: INITIAL_STATE.transportCardData,
      };

    // FILTER TRANSPORT CARDS
    case TransportCardsTypes.FILTER_TRANSPORT_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardsList: INITIAL_STATE.transportCardsList,
      };

    case TransportCardsTypes.FILTER_TRANSPORT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardsList: action.payload.transportCardsList,
        totalCount: action.payload.totalCount,
      };

    case TransportCardsTypes.FILTER_TRANSPORT_CARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardsList: INITIAL_STATE.transportCardsList,
      };

    // GET_TRANSPORT_CARD_FROM_NUMBER
    case TransportCardsTypes.GET_TRANSPORT_CARD_FROM_NUMBER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardData: INITIAL_STATE.transportCardData,
      };
    case TransportCardsTypes.GET_TRANSPORT_CARD_FROM_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardData: action.payload.transportCardData,
      };
    case TransportCardsTypes.GET_TRANSPORT_CARD_FROM_NUMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardData: INITIAL_STATE.transportCardData,
      };

    // CREATE TRANSPORT CARD
    case TransportCardsTypes.CREATE_TRANSPORT_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardData: INITIAL_STATE.transportCardData,
      };
    case TransportCardsTypes.CREATE_TRANSPORT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardData: action.payload.transportCardData,
      };
    case TransportCardsTypes.CREATE_TRANSPORT_CARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardData: INITIAL_STATE.transportCardData,
      };

    // CREATE TRANSPORT CARDS
    case TransportCardsTypes.CREATE_TRANSPORT_CARDS_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.CREATE_TRANSPORT_CARDS_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.CREATE_TRANSPORT_CARDS_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE TRANSPORT CARD
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE TRANSPORT CARD STATUS
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_STATUS_REQUEST:
      return { ...state, loading: true, error: false };

    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_STATUS_SUCCESS:
      return { ...state, loading: false, error: false };

    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_STATUS_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE TRANSPORT CARD
    case TransportCardsTypes.DELETE_TRANSPORT_CARD_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.DELETE_TRANSPORT_CARD_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.DELETE_TRANSPORT_CARD_FAILURE:
      return { ...state, loading: false, error: true };

    // REQUEST TRANSPORT CARD
    case TransportCardsTypes.REQUEST_TRANSPORT_CARD_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.REQUEST_TRANSPORT_CARD_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.REQUEST_TRANSPORT_CARD_FAILURE:
      return { ...state, loading: false, error: true };

    // ACTIVATE TRANSPORT CARD
    case TransportCardsTypes.ACTIVATE_TRANSPORT_CARD_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.ACTIVATE_TRANSPORT_CARD_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.ACTIVATE_TRANSPORT_CARD_FAILURE:
      return { ...state, loading: false, error: true };

    // ASSIGN TRANSPORT CARD
    case TransportCardsTypes.ASSIGN_TRANSPORT_CARD_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.ASSIGN_TRANSPORT_CARD_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.ASSIGN_TRANSPORT_CARD_FAILURE:
      return { ...state, loading: false, error: true };

    // UNASSIGN TRANSPORT CARD
    case TransportCardsTypes.UNASSIGN_TRANSPORT_CARD_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.UNASSIGN_TRANSPORT_CARD_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.UNASSIGN_TRANSPORT_CARD_FAILURE:
      return { ...state, loading: false, error: true };

    // CASE UPDATE TRANSPORT CARD SETTINGS
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_SETTINGS_REQUEST:
      return { ...state, loading: true, error: false };
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_SETTINGS_SUCCESS:
      return { ...state, loading: false, error: false };
    case TransportCardsTypes.UPDATE_TRANSPORT_CARD_SETTINGS_FAILURE:
      return { ...state, loading: false, error: true };

    // GET_TRANSPORT_CARD_SETTINGS_REQUEST
    case TransportCardsTypes.GET_TRANSPORT_CARD_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardSettings: INITIAL_STATE.transportCardSettings,
      };
    case TransportCardsTypes.GET_TRANSPORT_CARD_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardSettings: action.payload.transportCardSettings,
      };
    case TransportCardsTypes.GET_TRANSPORT_CARD_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardSettings: INITIAL_STATE.transportCardSettings,
      };

    default:
      return state;
  }
};

export default reducer;
